import React, { useMemo, useState } from 'react';

import { CardMedia, CardName, CardPrices, ControlTrigger } from '@pkg/components';
import { type MarketplaceCardProps } from '@pkg/components/Common/CardTile/types/token';

import { useIsPreview } from '@app/pages/ProfilePage/hooks/useIsPreview';
import { useNFTsPageStore } from '@app/store/zustand';

import { CardMarketplaceControls } from './CardMarketplaceControls';

import { CardInside, CardMediaHolder, Wrapper } from './styles';

export const MarketplaceCard = ({
    item,
    cardSize,
    isOwner,
    height,
    collectionData,
    hideCollectionData = false,
}: MarketplaceCardProps) => {
    const { imageUrl, id, animationUrl, hidden, orders, collection } = item || {};

    const { selectedItems } = useNFTsPageStore();

    const [isHovering, setIsHovering] = useState(false);
    const isSelected = selectedItems.includes(id || '');

    const isPreview = useIsPreview();
    const floorPrice = useMemo(
        () => collection?.marketData?.floorPrice || collectionData?.marketData?.floorPrice,
        [collection?.marketData?.floorPrice, collectionData?.marketData?.floorPrice],
    );
    const marketPlaceControlAnimation = {
        initial: { opacity: 0, scale: 0.8, y: 20 },
        animate: { opacity: 1, scale: 1, y: 0 },
        exit: { opacity: 0, scale: 0.8, y: 20 },
    };
    const optionsElement = item ? (
        <CardMarketplaceControls item={item} isHovering={isHovering} isOwner={isOwner && !isPreview} />
    ) : undefined;

    if ((!isOwner && hidden) || (isOwner && isPreview && hidden)) return null;
    const ordersWithPricing = orders?.filter((order) => !!order.price);

    return (
        <Wrapper>
            <CardInside $cardSize={cardSize} $height={height} $isSelected={isSelected}>
                <CardMediaHolder>
                    <ControlTrigger
                        optionsElement={optionsElement}
                        onIsHovering={(hovering) => setIsHovering(hovering)}
                        customAnimation={marketPlaceControlAnimation}
                    >
                        <CardMedia
                            prioritizeImage
                            item={item}
                            image_url={imageUrl}
                            animation_url={animationUrl}
                            cardSize={cardSize}
                            isHovering={isHovering}
                            isOwner={isOwner}
                            collectionData={collectionData || collection}
                        />
                    </ControlTrigger>
                </CardMediaHolder>

                <CardName
                    item={item}
                    cardSize={cardSize}
                    hideCollectionData={hideCollectionData}
                    collectionData={collectionData || collection}
                />

                {ordersWithPricing && ordersWithPricing?.length ? (
                    <CardPrices item={item} cardSize={cardSize} floorPriceWei={floorPrice} />
                ) : null}
            </CardInside>
        </Wrapper>
    );
};
